import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "mobx-react";
import { enableLogging } from "mobx-logger";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";

import { RouteNavMapping } from "constants/rotues";
import db from "xmov-lib/modules/db";
import store from "store";

import App from "./app";
import reportWebVitals from "./reportWebVitals";

import "./styles/index.less";
import "./styles/index.scss";

enableLogging();

function render() {
  ReactDOM.render(
    <ConfigProvider locale={zhCN}>
      <Provider {...store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ConfigProvider>,
    document.getElementById("root")
  );
}

function startApp(cb: Function) {
  const { pathname } = window.location;
  console.log(pathname);
  Object.keys(RouteNavMapping).forEach((key: string) => {
    if (pathname.indexOf(key) > -1) {
      // @ts-ignore
      store.appStore.setNav(RouteNavMapping[key]);
    }
  });
  store.appStore.setXhr();
  db.get("token").then((data: IUser) => {
    store.appStore.setUser(data);
    cb();
  });
}

startApp(render);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
